import { render, staticRenderFns } from "./leaveclaimfrm.vue?vue&type=template&id=71c402fa"
import script from "./leaveclaimfrm.vue?vue&type=script&lang=js"
export * from "./leaveclaimfrm.vue?vue&type=script&lang=js"
import style0 from "./leaveclaimfrm.vue?vue&type=style&index=0&id=71c402fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports